module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reward",
    staticStyle: {
      "min-height": "285px"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.reward.price))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.reward.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("truncate")(_vm.reward.description, 40)))]), _vm._v(" "), (_vm.showButtons) ? _c('div', [_c('button', {
    class: 'btn btn-default btn-lg button-wide-' + _vm.buttonColor,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showEditForm = true
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("edit")) + "\n    ")]), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg button-wide-' + _vm.buttonColor,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteModal = true
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("remove")) + "\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.showDeleteModal) ? _c('remove-reward', {
    attrs: {
      "close": _vm.closeModal,
      "rewards": _vm.rewards,
      "reward": _vm.reward
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showEditForm) ? _c('reward-form', {
    attrs: {
      "close": _vm.closeForm,
      "rewards": _vm.rewards,
      "reward": _vm.reward,
      "action": 'edit',
      "buttonColor": _vm.buttonColor,
      "currency": _vm.currency
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f4599ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reward/Tile.vue
// module id = 793
// module chunks = 1